import { I18nPluralPipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { interval, Subject, takeUntil } from 'rxjs';
import { IdleService } from './idle.service';

export interface IdleDialogData {
    logoutAt: number;
}

@Component({
    selector: 'dialog-idle',
    templateUrl: './dialog-idle.component.html',
    styleUrls: ['./dialog-idle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [I18nPluralPipe, MatButtonModule, MatDialogModule, MatIconModule],
})
export class DialogIdleComponent implements OnInit, OnDestroy {
    remainingSeconds = 0;
    private readonly _destroy$ = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) readonly data: IdleDialogData,
        private readonly _dialogRef: MatDialogRef<DialogIdleComponent>,
        private readonly _idleService: IdleService,
        private readonly _changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.updateCountdown();

        interval(1000)
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => this.updateCountdown());
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    staySignedIn(): void {
        this._idleService.confirmActivity();
        this._dialogRef.close('active');
    }

    signOut(): void {
        this._idleService.expireSession();
        this._dialogRef.close('logout');
    }

    get minutes(): number {
        return Math.floor(this.remainingSeconds / 60);
    }

    get seconds(): number {
        return this.remainingSeconds % 60;
    }

    private updateCountdown(): void {
        this.remainingSeconds = Math.max(
            0,
            Math.ceil((this.data.logoutAt - Date.now()) / 1000)
        );
        this._changeDetectorRef.markForCheck();

        if (this.remainingSeconds === 0) {
            this._idleService.expireSession();
        }
    }
}
